// extracted by mini-css-extract-plugin
export default {"header":"Header_header__qvskS","logo":"Header_logo__mhafy","active":"Header_active__60TI+"};